import React, { useEffect, useState } from 'react';

import { apiBaseUrl } from '../util/api';

import css from './OffersList.module.css';

const formatPrice = amount => `$${(Number(amount || 0) / 100).toFixed(2)}`;
const statusLabel = status => `${status || 'pending'}`.replace(/^./, char => char.toUpperCase());

const OffersList = ({ sellerView = false }) => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${apiBaseUrl()}/api/offers${sellerView ? '?role=seller' : ''}`, { credentials: 'include' })
      .then(async response => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to load offers.');
        return data.offers || [];
      })
      .then(data => active && setOffers(data))
      .catch(requestError => active && setError(requestError.message))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [sellerView]);

  const respond = (offerId, status) => {
    fetch(`${apiBaseUrl()}/api/offers/${offerId}`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status }),
    })
      .then(async response => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to update offer.');
        return data.offer;
      })
      .then(updated => setOffers(current => current.map(offer => offer.id === updated.id ? { ...offer, ...updated } : offer)))
      .catch(requestError => setError(requestError.message));
  };

  if (loading) return <p className={css.message}>Loading offers...</p>;
  if (error) return <p className={css.error}>{error}</p>;
  if (!offers.length) return <p className={css.message}>No offers yet.</p>;

  return (
    <div className={css.list}>
      {offers.map(offer => (
        <article key={offer.id} className={css.offer}>
          {offer.listing?.image ? <img className={css.image} src={offer.listing.image} alt="" /> : <div className={css.imagePlaceholder} />}
          <div className={css.details}>
            <h3 className={css.title}>{offer.listing?.title || 'Unavailable listing'}</h3>
            {!sellerView ? <p className={css.meta}>Seller: {offer.listing?.sellerName || 'Seller'}</p> : null}
            <p className={css.meta}>Asking price: {formatPrice(offer.askingPriceSubunits)}</p>
            <p className={css.offerPrice}>Offer: {formatPrice(offer.offerPriceSubunits)}</p>
            <p className={css.meta}>Submitted: {new Date(offer.createdAt).toLocaleString()}</p>
          </div>
          <div className={css.actions}>
            <span className={css.status}>{statusLabel(offer.status)}</span>
            {sellerView && offer.status === 'pending' ? (
              <div className={css.responseActions}>
                <button type="button" className={css.decline} onClick={() => respond(offer.id, 'declined')}>Decline</button>
                <button type="button" className={css.accept} onClick={() => respond(offer.id, 'accepted')}>Accept</button>
              </div>
            ) : null}
          </div>
        </article>
      ))}
    </div>
  );
};

export default OffersList;
